function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _extends() {
  return (_extends = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function _typeof(t) {
  return (_typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (t) {
    return _typeof2(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof2(t);
  })(t);
}

!function (t, e) {
  "object" === ("undefined" == typeof exports ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = t || self).LazyLoad = e();
}(this, function () {
  "use strict";

  var t = "undefined" != typeof window,
      e = t && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),
      n = t && "IntersectionObserver" in window,
      o = t && "classList" in document.createElement("p"),
      r = {
    elements_selector: "img",
    container: e || t ? document : null,
    threshold: 300,
    thresholds: null,
    data_src: "src",
    data_srcset: "srcset",
    data_sizes: "sizes",
    data_bg: "bg",
    data_poster: "poster",
    class_loading: "loading",
    class_loaded: "loaded",
    class_error: "error",
    load_delay: 0,
    auto_unobserve: !0,
    callback_enter: null,
    callback_exit: null,
    callback_reveal: null,
    callback_loaded: null,
    callback_error: null,
    callback_finish: null,
    use_native: !1
  },
      a = function a(t, e) {
    var n,
        o = new t(e);

    try {
      n = new CustomEvent("LazyLoad::Initialized", {
        detail: {
          instance: o
        }
      });
    } catch (t) {
      (n = document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized", !1, !1, {
        instance: o
      });
    }

    window.dispatchEvent(n);
  };

  var s = function s(t, e) {
    return t.getAttribute("data-" + e);
  },
      i = function i(t, e, n) {
    var o = "data-" + e;
    null !== n ? t.setAttribute(o, n) : t.removeAttribute(o);
  },
      c = function c(t) {
    return "true" === s(t, "was-processed");
  },
      l = function l(t, e) {
    return i(t, "ll-timeout", e);
  },
      u = function u(t) {
    return s(t, "ll-timeout");
  },
      d = function d(t, e, n, o) {
    t && (void 0 === o ? void 0 === n ? t(e) : t(e, n) : t(e, n, o));
  },
      f = function f(t, e) {
    t.loadingCount += e, 0 === t._elements.length && 0 === t.loadingCount && d(t._settings.callback_finish, t);
  },
      _ = function _(t) {
    for (var e, n = [], o = 0; e = t.children[o]; o += 1) {
      "SOURCE" === e.tagName && n.push(e);
    }

    return n;
  },
      v = function v(t, e, n) {
    n && t.setAttribute(e, n);
  },
      g = function g(t, e) {
    v(t, "sizes", s(t, e.data_sizes)), v(t, "srcset", s(t, e.data_srcset)), v(t, "src", s(t, e.data_src));
  },
      m = {
    IMG: function IMG(t, e) {
      var n = t.parentNode;
      n && "PICTURE" === n.tagName && _(n).forEach(function (t) {
        g(t, e);
      });
      g(t, e);
    },
    IFRAME: function IFRAME(t, e) {
      v(t, "src", s(t, e.data_src));
    },
    VIDEO: function VIDEO(t, e) {
      _(t).forEach(function (t) {
        v(t, "src", s(t, e.data_src));
      }), v(t, "poster", s(t, e.data_poster)), v(t, "src", s(t, e.data_src)), t.load();
    }
  },
      h = function h(t, e) {
    var n,
        o,
        r = e._settings,
        a = t.tagName,
        i = m[a];
    if (i) return i(t, r), f(e, 1), void (e._elements = (n = e._elements, o = t, n.filter(function (t) {
      return t !== o;
    })));
    !function (t, e) {
      var n = s(t, e.data_src),
          o = s(t, e.data_bg);
      n && (t.style.backgroundImage = 'url("'.concat(n, '")')), o && (t.style.backgroundImage = o);
    }(t, r);
  },
      p = function p(t, e) {
    o ? t.classList.add(e) : t.className += (t.className ? " " : "") + e;
  },
      b = function b(t, e) {
    o ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(^|\\s+)" + e + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, "");
  },
      y = function y(t, e, n) {
    t.addEventListener(e, n);
  },
      E = function E(t, e, n) {
    t.removeEventListener(e, n);
  },
      w = function w(t, e, n) {
    E(t, "load", e), E(t, "loadeddata", e), E(t, "error", n);
  },
      I = function I(t, e, n) {
    var o = n._settings,
        r = e ? o.class_loaded : o.class_error,
        a = e ? o.callback_loaded : o.callback_error,
        s = t.target;
    b(s, o.class_loading), p(s, r), d(a, s, n), f(n, -1);
  },
      k = function k(t, e) {
    var n = function n(r) {
      I(r, !0, e), w(t, n, o);
    },
        o = function o(r) {
      I(r, !1, e), w(t, n, o);
    };

    !function (t, e, n) {
      y(t, "load", e), y(t, "loadeddata", e), y(t, "error", n);
    }(t, n, o);
  },
      A = ["IMG", "IFRAME", "VIDEO"],
      L = function L(t, e) {
    var n = e._observer;
    O(t, e), n && e._settings.auto_unobserve && n.unobserve(t);
  },
      x = function x(t) {
    var e = u(t);
    e && (clearTimeout(e), l(t, null));
  },
      z = function z(t, e) {
    var n = e._settings.load_delay,
        o = u(t);
    o || (o = setTimeout(function () {
      L(t, e), x(t);
    }, n), l(t, o));
  },
      O = function O(t, e, n) {
    var o = e._settings;
    !n && c(t) || (A.indexOf(t.tagName) > -1 && (k(t, e), p(t, o.class_loading)), h(t, e), function (t) {
      i(t, "was-processed", "true");
    }(t), d(o.callback_reveal, t, e), d(o.callback_set, t, e));
  },
      N = function N(t) {
    return !!n && (t._observer = new IntersectionObserver(function (e) {
      e.forEach(function (e) {
        return function (t) {
          return t.isIntersecting || t.intersectionRatio > 0;
        }(e) ? function (t, e, n) {
          var o = n._settings;
          d(o.callback_enter, t, e, n), o.load_delay ? z(t, n) : L(t, n);
        }(e.target, e, t) : function (t, e, n) {
          var o = n._settings;
          d(o.callback_exit, t, e, n), o.load_delay && x(t);
        }(e.target, e, t);
      });
    }, {
      root: (e = t._settings).container === document ? null : e.container,
      rootMargin: e.thresholds || e.threshold + "px"
    }), !0);
    var e;
  },
      C = ["IMG", "IFRAME"],
      M = function M(t, e) {
    return function (t) {
      return t.filter(function (t) {
        return !c(t);
      });
    }((n = t || function (t) {
      return t.container.querySelectorAll(t.elements_selector);
    }(e), Array.prototype.slice.call(n)));
    var n;
  },
      S = function S(t) {
    var e = t._settings;
    e.container.querySelectorAll("." + e.class_error).forEach(function (t) {
      b(t, e.class_error), function (t) {
        i(t, "was-processed", null);
      }(t);
    }), t.update();
  },
      R = function R(e, n) {
    var o;
    this._settings = function (t) {
      return _extends({}, r, t);
    }(e), this.loadingCount = 0, N(this), this.update(n), o = this, t && window.addEventListener("online", function (t) {
      S(o);
    });
  };

  return R.prototype = {
    update: function update(t) {
      var n,
          o = this,
          r = this._settings;
      (this._elements = M(t, r), !e && this._observer) ? (function (t) {
        return t.use_native && "loading" in HTMLImageElement.prototype;
      }(r) && ((n = this)._elements.forEach(function (t) {
        -1 !== C.indexOf(t.tagName) && (t.setAttribute("loading", "lazy"), O(t, n));
      }), this._elements = M(t, r)), this._elements.forEach(function (t) {
        o._observer.observe(t);
      })) : this.loadAll();
    },
    destroy: function destroy() {
      var t = this;
      this._observer && (this._elements.forEach(function (e) {
        t._observer.unobserve(e);
      }), this._observer = null), this._elements = null, this._settings = null;
    },
    load: function load(t, e) {
      O(t, this, e);
    },
    loadAll: function loadAll() {
      var t = this;

      this._elements.forEach(function (e) {
        L(e, t);
      });
    }
  }, t && function (t, e) {
    if (e) if (e.length) for (var n, o = 0; n = e[o]; o += 1) {
      a(t, n);
    } else a(t, e);
  }(R, window.lazyLoadOptions), R;
});